import { shiyong_url } from "@/components/const";
import { PageSubTitle, PageTitle } from "@/components/pageTitle";

export const SdwanProposal = () => {
  return (
    <div className="flex justify-center ">
      {" "}
      <div className="px-[200px] pt-[200px] w-[1920px]">
        <PageTitle title="光年无界 企业出海网络解决方案" />
        <PageSubTitle title="让企业出海网络搭建变得更简单" />
        <div className="flex h-[390px] gap-[20px]  mt-[69px]">
          <div className="flex-1 bg-gradient-to-br from-[#D7E6FE] to-[#FFFFFF] rounded-[20px] border border-[#D9DEFF] p-[30px] flex relative">
            <div>
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[30px] text-[#003366]">
                全球SD-WAN网络加速服务
              </div>
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[rgba(0,51,102,0.6)] mt-[10px]">
                通过光年自研K-WAN加速引擎在全球部署节点组建专用骨干网络，为企业提供安全、合规、稳定的全球互联网服务
              </div>
              <Item content="线路采用三大运营商国际专线组建，安全合规可靠" />
              <Item content="采用自研K-WAN加速引擎，极简配置，多种部署模式" />
              <Item content="协助企业构建高性价比的专属全场景网络连接方案" />
              <Item content="支持跨境电商、海外直播、外贸企业、企业跨国组网多场景使用" />
              <Item content="低延迟、丢包少，支持企业定制" />
            </div>
            <img className="w-[430px] h-[320px] " src="/imgs/sdwan/5.png" />
            <div className="w-[164px] h-[53px] bg-gradient-to-br from-[#5FD7FF] to-[#0151FF] rounded-[8px] absolute bottom-[30px] right-[30px] flex items-center justify-center">
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#FFFFFF]">
                查看详情
              </div>
            </div>
          </div>
          <div
            className="w-[27%] bg-blue-500 bg-gradient-to-b from-[#D8E7FE] to-[#FFFFFF]
        rounded-[20px] border border-[#DDE9FE] flex flex-col overflow-hidden"
          >
            <div className="bg-gradient-to-tr from-[#6DE3FD] via-[#ABE6FD] to-[#95B4F7] h-[200px] px-[36px] py-[6px] flex items-center justify-center">
              <img className=" h-full object-cover" src="/imgs/sdwan/7.png" />
            </div>
            <div className="flex-1 px-[20px]">
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[28px] text-[#003366] mt-[35px]">
                企业组网/私有化部署
              </div>
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[rgba(0,51,102,0.6)] mt-[10px]">
                跨国办公，直播引流和AI创作全都搞定，解决企业客户海外获客与客户建联时的各种痛点需求
              </div>
            </div>
          </div>
        </div>

        <div className="flex h-[390px] gap-[20px]  mt-[20px]">
          <div className="flex-1 bg-gradient-to-br from-[#D7E6FE] to-[#FFFFFF] rounded-[20px] border border-[#D9DEFF] p-[30px] flex relative">
            <div>
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[30px] text-[#003366]">
                全球直播专线/TK直播养号
              </div>
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[rgba(0,51,102,0.6)] mt-[10px]">
                提供TikTok、Shopee等常用海外平台直播专线，0卡顿、不封号，助力TikTok养号/矩阵/直播等多类业务场景
              </div>
              <Item content="使用自研加速引擎，保证直播数据流畅传输" />
              <Item content="经得起三方检测的独享原生家庭IP、确保IP纯净度" />
              <Item content="采用运营商专线互联，可直签确保合规性" />
              <Item content="支持多账号、多IP同时直播" />
              <Item content="支持软件/硬件接入网络，灵活使用更方便" />
            </div>
            <img className="w-[430px] h-[320px] " src="/imgs/sdwan/6.png" />
            <div className="w-[164px] h-[53px] bg-gradient-to-br from-[#5FD7FF] to-[#0151FF] rounded-[8px] absolute bottom-[30px] right-[30px] flex items-center justify-center">
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#FFFFFF]">
                查看详情
              </div>
            </div>
          </div>
          <div
            className="w-[27%] bg-blue-500 bg-gradient-to-b from-[#D8E7FE] to-[#FFFFFF]
        rounded-[20px] border border-[#DDE9FE] flex flex-col overflow-hidden"
          >
            <div className=" bg-gradient-to-br from-[#6DA7FD] via-[#E2CDFF] to-[#BED3FF] h-[200px] px-[36px] py-[6px] flex items-center justify-center">
              <img className=" h-full object-cover" src="/imgs/sdwan/8.png" />
            </div>
            <div className="flex-1 px-[20px]">
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[28px] text-[#003366] mt-[35px]">
                企业组网/私有化部署
              </div>
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[rgba(0,51,102,0.6)] mt-[10px]">
                跨国办公，直播引流和AI创作全都搞定，解决企业客户海外获客与客户建联时的各种痛点需求
              </div>
            </div>
          </div>
        </div>

        <div className="mt-[20px] w-full flex items-center justify-center">
          <div className="flex-1" />

          <a href={shiyong_url} target="_blank">
            <div
              className="w-[150px] h-[40px] rounded-[10px] relative flex items-center justify-center"
              style={{
                background:
                  "linear-gradient(275deg, rgba(89, 207, 255, 1), rgba(112, 161, 255, 1))",
                padding: "2px",
              }}
            >
              <div className="w-full h-full bg-white rounded-[8px] flex items-center justify-center">
                <span className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-left bg-gradient-to-t from-[#4A86FF] to-[#55C9FF] bg-clip-text text-transparent">
                  更多定制化需求
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export const Item = (props: { content: string }) => {
  const { content } = props;
  return (
    <div className="flex mt-[15px] items-center ">
      <div className="w-[24px] h-[24px]  rounded-full mr-[12px]">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_18031_7799)">
            <path
              d="M0 12C0 5.37269 5.37269 0 12 0C18.6273 0 24 5.37269 24 12C24 18.6273 18.6273 24 12 24C5.37269 24 0 18.6273 0 12ZM9.82759 16.5617C9.97832 16.7171 10.184 16.8073 10.4004 16.8128C10.6168 16.8184 10.8269 16.7389 10.9854 16.5914L18.8491 9.28055C19.0087 9.13083 19.1024 8.92402 19.1099 8.70535C19.1174 8.48668 19.038 8.27394 18.889 8.11367C18.7401 7.9534 18.5337 7.85863 18.3151 7.8501C18.0964 7.84157 17.8833 7.91996 17.7223 8.06814L10.4772 14.8543L7.07586 11.347C7.00045 11.268 6.91012 11.2046 6.81009 11.1606C6.71007 11.1167 6.60232 11.0929 6.49308 11.0908C6.38383 11.0887 6.27525 11.1082 6.17359 11.1483C6.07193 11.1883 5.97921 11.2481 5.90078 11.3242C5.82235 11.4003 5.75977 11.4912 5.71663 11.5915C5.6735 11.6919 5.65068 11.7999 5.64947 11.9091C5.64827 12.0184 5.66872 12.1268 5.70964 12.2281C5.75055 12.3295 5.81113 12.4217 5.88786 12.4994L9.828 16.5617H9.82759Z"
              fill="#74B9FF"
            />
          </g>
          <defs>
            <clipPath id="clip0_18031_7799">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[#003366]">
        {content}
      </div>
    </div>
  );
};
